/**
 * Comportement des éléments du secondary header (active class au clic et au scroll)
 * @author Sandrine M'zé
 * par artwaï pour artwaï
 *
 */

const menu = {

    postTitles: [], // Eléments section-description dans l'article
    entries: [], // Eléments a du menu

    init: function() {
        const scrollContainer = document.querySelector('.formation-secondary-header-container');
        menu.postTitles = document.querySelectorAll('section');
        menu.entries = document.querySelectorAll('.secondary-menu-item');

        if (scrollContainer.scrollWidth > scrollContainer.clientWidth) {
            let isDown = false;
            let startX;
            let scrollLeft;
            scrollContainer.classList.add('grabbed');
            scrollContainer.addEventListener('mousedown', (e) => {
                isDown = true;
                scrollContainer.classList.add('active');
                startX = e.pageX - scrollContainer.offsetLeft;
                scrollLeft = scrollContainer.scrollLeft;
            });
    
            scrollContainer.addEventListener('mouseleave', () => {
                isDown = false;
                scrollContainer.classList.remove('active');
            });
    
            scrollContainer.addEventListener('mouseup', () => {
                isDown = false;
                scrollContainer.classList.remove('active');
            });
    
            scrollContainer.addEventListener('mousemove', (e) => {
                if(!isDown) return;
                e.preventDefault();
                const x = e.pageX - scrollContainer.offsetLeft;
                const walk = (x - startX) * 2; // Ajustez la vitesse de défilement si nécessaire
                scrollContainer.scrollLeft = scrollLeft - walk;
            });
        }

        menu.handlePageScroll();

    },

    /**
     * Dynamisation du menu au scroll
     */
    handlePageScroll: function() {
        const intersectionObserver = new IntersectionObserver(entries => {
            for (const entry of entries) {
                for (let item of menu.entries) {
                    if (entry.isIntersecting) {
                        item.classList.toggle('active', item.dataset.id === entry.target.id );
                    }
                }
            }
        }, {
            root: null,

            // Option d'intersection à 80% du bas du viewport
            rootMargin: "0px 0px -60% 0px",
        });

        for (const entry of menu.postTitles) {
            intersectionObserver.observe(entry);
        }

    }
}

document.addEventListener('DOMContentLoaded', menu.init);